export default function redirectToCloudManagement() {
  return Promise.resolve(null)
}
